var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cardRow)?_c('NebulaGridRow',{attrs:{"gutter":""}},_vm._l((_vm.cardCount),function(n){return _c('NebulaGridBlock',{key:n,class:_vm.className,attrs:{"columns":Math.floor(12 / _vm.cardCount),"mdSize":Math.floor(12 / _vm.cardCount),"smSize":Math.floor(12 / _vm.cardCount)}})}),1):_c('div',{class:_vm.className})
}
var staticRenderFns = []

export { render, staticRenderFns }